"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const range = (num) => (num <= 100 ? (num > 0 ? num : 0) : 100);
const ProgressBar = (props) => {
    const { title, className, withPercentage, progress = 0, width = "77px", height = "8px", borderRadius = 15 } = props;
    const rangedProgress = range(progress);
    return (react_1.default.createElement("div", { title: title, role: "progressbar", "aria-valuenow": rangedProgress, className: (0, classnames_1.default)("gerudo-progressbar-container", className) },
        react_1.default.createElement("div", { style: { width, height, borderRadius }, className: "gerudo-progressbar-preview" },
            react_1.default.createElement("div", { className: "gerudo-progressbar-state", style: { width: `${rangedProgress}%` } })),
        withPercentage && react_1.default.createElement("span", { className: "gerudo-progressbar-number" },
            rangedProgress,
            "%")));
};
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map